import { useTeam } from "@hooks";
import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { AccountItemLine } from "../AccountItem";
import FeatureToggle from "../FeatureToggle";
import SelectTeam from "./SelectTeam";
import { DSButton } from "../../design-system/molecules";

export default function TeamSettings() {
  const { userTeams, currentTeam, setCurrentTeam } = useTeam();
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex flex-col gap-md">
      {currentTeam?.uuid ? (
        <div className="flex-1 divide-y divide-secondary">
          <AccountItemLine
            title="Current Team Name:"
            dataTestId="team-name-line"
          >
            <span className="text-primary">{currentTeam?.name}</span>
            <AvatarGroup max={8}>
              {currentTeam?.users?.map((user) => (
                <Tooltip
                  key={user.uuid}
                  arrow
                  placement="top"
                  title={`${user?.firstName} ${user?.lastName}`}
                >
                  <Avatar
                    sx={{ width: 24, height: 24, fontSize: 10 }}
                  >
                    {user?.firstName.charAt(0)}
                    {user?.lastName.charAt(0)}
                  </Avatar>
                </Tooltip>
              ))}
            </AvatarGroup>
          </AccountItemLine>

          {userTeams?.length && userTeams.length > 1 ? (
            <AccountItemLine
              title="Switch Current Team:"
              dataTestId="team-switch-line"
            >
              <SelectTeam
                currentTeam={currentTeam}
                setCurrentTeam={setCurrentTeam}
                showLabel={false}
              />
            </AccountItemLine>
          ) : null}

          <AccountItemLine dataTestId="team-transfer-notes-line">
            <FeatureToggle
              title="Transfer New Notes"
              description={
                <>
                  Turning this setting on will open a menu to transfer
                  new recordings after pressing the stop button.
                  <br />
                  <br />
                  <i>When to use:</i> This setting is useful if you're
                  primarily recording on behalf of other members of
                  the care team (eg. when assisting a DVM).
                  <br />
                  <br />
                  <i>When not to use:</i> If you want to maintain
                  ownership of your notes (eg. if you are a DVM).
                </>
              }
              flagKey="transferNewNotes"
              segmentKey="transfer-new-notes"
            />
          </AccountItemLine>
        </div>
      ) : (
        <div className="w-full flex flex-col items-center justify-between gap-md">
          <span className="text-secondary">
            Teams Mode allows you to use Scribenote with your clinic,
            letting you share notes and templates. Invite your team to
            get started!
          </span>
          <DSButton
            variant="primary"
            onClick={() => navigate("/teams")}
            dataTestId="invite-team-button"
          >
            Invite My Team
          </DSButton>
        </div>
      )}
    </div>
  );
}
